import React from 'react'
import "./Footer.css"
import gitHubIcon from "../assets/github-mark.png"
import linkedInIcon from "../assets/InBug-Black.png"
import discordIcon from "../assets/Discord-Symbol-Black.png"

export default function Footer() {
  return (
    <div className='footerContainer'>
      <ul className='footerList'>
        <li className='footerAdress'>janironkainen.com</li>
        <li className='footerListItem'>
          <a href="https://github.com/t3roja" target="_blank" rel="noopener noreferrer">
            <img className='footerIcon' src={gitHubIcon} alt='Github' />
          </a>
        </li>

        <li className='footerListItem'>
          <a href="https://www.linkedin.com/in/jani-ronkainen-216190210/" target="_blank" rel="noopener noreferrer">
            <img className='footerIcon' src={linkedInIcon} alt='Github' />
          </a>
        </li>

        <li className='footerListItem'>
          <a href="https://discordapp.com/users/1144168289027756125" target="_blank" rel="noopener noreferrer">
            <img className='footerIcon' src={discordIcon} alt='Discord' />
          </a>
        </li>

        
      </ul>
    </div>

  )
}
